import { baseAPI } from "@/util/api.type";
import { UploadFileAPI } from "../upload/upload.service";
import { CallAPI_Upload, UploadRequestParams } from "../upload/api";
import { CallAPI_Submission } from "./api";
import { CUSTOMER_LEVEL } from "@prisma/client";

export async function SubmitFormAPI(formId: any, submissionData: any, trackingData: any, userId: any): Promise<any> {
    try {
        // ค้นหาและจัดการฟิลด์ที่ลงท้ายด้วย "_File"
        const keysToProcess = Object.keys(submissionData).filter((key) => key.endsWith("_File"));

        for (const key of keysToProcess) {
            const baseKey = key.replace("_File", ""); // เช่น field2_File -> field2
            const files = submissionData[key]; // ไฟล์ที่อยู่ใน _File

            if (Array.isArray(files)) {
                const uploadPromises = files.map(async (file: any) => {
                    const fileBlob = new Blob([file], { type: file.type });

                    const uploadedFile = await UploadFileAPI(fileBlob, "form");
                    // เพิ่มชื่อไฟล์เดิมเข้าไปในผลลัพธ์
                    return {
                        ...uploadedFile,
                        originalFileName: file.name, // เพิ่มชื่อไฟล์เดิม
                    };
                });

                const uploadedFiles = await Promise.all(uploadPromises);

                submissionData[baseKey] = uploadedFiles;
                delete submissionData[key];
            }
        }

        // สร้าง FormData สำหรับส่งฟอร์ม
        const formData = new FormData();
        formData.append("formId", formId);
        formData.append("submissionData", JSON.stringify(submissionData));
        formData.append("trackingData", JSON.stringify(trackingData));
        formData.append("userId", userId ? userId : CUSTOMER_LEVEL.GUEST);

        const response = await fetch(`/api/submit-form`, {
            method: "POST",
            body: formData,
        });

        if (response.status === 403) {
            throw new Error("error.submit-form.403");
        }

        const result = (await response.json()) as baseAPI<any>;

        if (result.statusCode === 200) {
            CallAPI_Submission(result.result.id);
            return result;
        }

        if (result.statusCode === 403) {
            throw new Error("error.submit-form.403");
        }

        throw new Error("error.submit-form");
    } catch (error) {
        console.error("Error submitting form:", error);
        throw new Error("error.submit-form.403");
    }
}
